import React, { useState } from 'react';
import { AddButton, EmptyState, FilterBar } from '../../../components/admin/Shared';
import CreatePartnerModal, {
  AdminPartner,
} from '../../../components/admin/CreatePartnerModal';

interface Partner {
  id: number;
  name: string;
}

interface Props {
  partners: Partner[];
  onSelect: (partnerId: number) => void;
  onPartnerCreated?: (partner: AdminPartner) => void;
}

export default function PartnersListTab({ partners, onSelect, onPartnerCreated }: Props) {
  const [showCreate, setShowCreate] = useState(false);

  return (
    <section className="admin-partners-list">
      <FilterBar actions={<AddButton onClick={() => setShowCreate(true)}>Add partner</AddButton>}>
        <span className="filter-item__hint">{partners.length} partner{partners.length === 1 ? '' : 's'}</span>
      </FilterBar>

      {partners.length === 0 ? (
        <EmptyState
          title="No partners yet"
          body="Create your first partner to assign couriers, warehouses, or master accounts."
          cta={<AddButton onClick={() => setShowCreate(true)}>Add partner</AddButton>}
        />
      ) : (
        <div className="partner-card-grid">
          {partners.map((p) => (
            <div
              key={p.id}
              className="partner-card"
              onClick={() => onSelect(p.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect(p.id);
                }
              }}
            >
              <div className="partner-card__name">{p.name}</div>
              <div className="partner-card__links">
                <span>Pricing</span>
                <span>·</span>
                <span>Vehicles</span>
                <span>·</span>
                <span>Service Areas</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <CreatePartnerModal
        show={showCreate}
        close={() => setShowCreate(false)}
        onSuccess={(partner) => {
          if (onPartnerCreated) onPartnerCreated(partner);
        }}
      />
    </section>
  );
}
